// import { JhiHttpInterceptor, JhiEventManager } from 'ng-jhipster';
import { Injectable } from '@angular/core';
import { RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.log('ErrorHandlerInterceptor called...');
        return next
            .handle(request)
            .do((ev: HttpEvent<any>) => {
                if (ev instanceof HttpResponse) {
                    alert(ev.headers.keys())
                    console.log('Error has occured...', ev);
                }
            }).catch(response => {
                if (response instanceof HttpErrorResponse) {
                    console.log('Processing http error', response);
                }
                return Observable.throw(response);
            });
    }

    // requestIntercept(options?: RequestOptionsArgs): RequestOptionsArgs {
    //     return options;
    // }

    // responseIntercept(observable: Observable<Response>): Observable<Response> {
    //     return <Observable<Response>> observable.catch((error) => {
    //         if (!(error.status === 401 && (error.text() === '' ||
    //             (error.json().path && error.json().path.indexOf('/api/account') === 0 )))) {
    //             this.eventManager.broadcast( {name: 'flightsApp.httpError', content: error});
    //         }
    //         return Observable.throw(error);
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/errorhandler.interceptor.ts